// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.87.1/styles/" + (chunkId === 225 ? "videojs" : chunkId) + ".chunk.css?" + {"225":"b795cead8084b3e6158e","753":"353faa143a2edd9cbb97"}[chunkId] + "";
};